import { reactive } from "vue";
import mitt from "mitt";
import { set } from "lodash";
const emitter = mitt();

export const eventBus = reactive({
    backNavigationHandler: null,
    contextualPaywall: {
        context: null,
        contextualProducts: null,
        user: null,
        partner: null,
        contextualProduct: null,
        adyenSession: null,
        agbVersionByDomain: null,
        orderUniqueIdentifier: null,
    },
    flash: {
        previousBanner: null,
        banner: null,
        user: null,
        partner: null,
        bannerData: null,
        coins: null,
        verificationId: null,
        verificationComplete: null,
        toast: null,
        inboxTrigger: null,
        context: null,
        paymentFrequency: null,
    },
    modalToOpen: null,
    clearFlash() {
        this.flash.banner = null;
        this.flash.partner = null;
        this.flash.bannerData = null;
        this.flash.toast = null;
    },
    clearContext() {
        this.contextualPaywall.contextualProduct = null;
        this.contextualPaywall.contextualProducts = null;
        this.contextualPaywall.adyenSession = null;
        this.contextualPaywall.agbVersionByDomain = null;
        this.contextualPaywall.orderUniqueIdentifier = null;
    },
    pushMessage(message, context, data) {
        const messageMap = {
            question_game_asked: {
                message: "messenger_question_game_asked",
                message_type: "question_game_asked",
                data: data,
            },
            question_game_answered: {
                message: "messenger_question_game_answered",
                message_type: "question_game_answered",
                data: data,
            },
            send_smile: {
                message: "messenger_smiley",
                message_type: "smiley",
                data: "[]",
            },
            share_my_photo: {
                message: "messenger_share_my_photo",
                message_type: "share_my_photo",
                data: data ?? "[]",
            },
            share_contact: {
                message: message,
                message_type: "share_" + data,
                data: "[]",
            },
            exclusive_message: {
                message: "messenger_sent_exclusive_message",
                message_type: "sent_exclusive_message",
                data: btoa(data?.content || ""),
            },
            compliment: {
                message: "messenger_made_compliment",
                message_type: "made_compliment",
                data: "[]",
            },
            send_rose: {
                message: "messenger_sent_rose",
                message_type: "sent_rose",
                data: "[]",
            },
            like: {
                message: message,
                message_type: data,
                data: "[]",
            },
        };

        const mappedMessage = messageMap[context];
        const newMessage = {
            message: mappedMessage.message,
            context: mappedMessage.message_type,
            data: mappedMessage.data || data,
        };

        emitter.emit("newPlaceholder", newMessage);
    },
    removeMessage(data) {
        emitter.emit("removedMessage", data);
    },
    updateLastMessage(message) {
        emitter.emit("updatedLastMessage", message);
    },
    updateConversation() {
        emitter.emit("updatedConversation");
    },
    newIncomingMessage(message) {
        emitter.emit("newIncomingMessage", message);
    },
    replaceTempMessage(data) {
        emitter.emit("replaceTempMessage", data);
    },
    messagesRead(data) {
        emitter.emit("messagesRead", data);
    },
    switchConversation(partner) {
        emitter.emit("switchConversation", partner);
    },
    updateSharePhoto(data) {
        emitter.emit("updatedSharePhoto", data);
    },
    selectSpecialMessage(type) {
        emitter.emit("selectedSpecialMessage", type);
    },
    deselectSpecialMessage() {
        emitter.emit("deselectedSpecialMessage");
    },
    replyToMessage(reply) {
        emitter.emit("replyToMessage", reply);
    },
    scrollToMessageNotFound: (messageId) => {
        emitter.emit("scrollToMessageNotFound", messageId);
    },
    clearReplyTo() {
        set(this, "replyTo", null);
        emitter.emit("clearReplyTo");
    },
    reportError(data) {
        emitter.emit("reportError", data);
    },
    on(event, callback) {
        emitter.on(event, callback);
    },
    off(event, callback) {
        emitter.off(event, callback);
    },
});
